/**
 * filter
 * @name lpad
 *
 * @description
 * filter that transform a number with so many left digits as needed to fill the length provided
 *
 * @param {string} string usually, the number to be lpaded
 * @param {number} length the total length of the returned string. Optional, default 2
 * @param {string} padString the pad string to be the base of the returned string. Optional, default '0'
 *
 * @example
 *  {{$ctrl.number | lpad}}
 *  {{$ctrl.number | lpad : 2 : '0'}}
 *  $filter(this.number)(number);
 *  $filter(this.number)(number, 2, '0');
 *
 * @return {string} a number filled with so many left digits as needed to the length provided. example: '02'
 **/
export default function() {
  return function(string, length, padString) {
    const DEFAULT_LENGTH = 2;
    const DEFAULT_PADSTRING = '0';
    length = length || DEFAULT_LENGTH;
    padString = padString || DEFAULT_PADSTRING;
    let pad = Array(length + 1).join(padString);
    return (pad + string).slice(-length);
  };
}



// WEBPACK FOOTER //
// ./client/app/common/filters/lpad.js